<div class="filter-by-module-content" *ngIf="!isLoading; else tableShimmer">
    <h3 class="mt-0 mb-12 shrink-0">{{ 'MODULE.SINGULAR' | translate }}</h3>
    <div class="table-actions-wrapper" [class.disabled]="!isTableActive">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-12 shrink-0">
            <app-tag-multi-select [tags]="tagService.tag$ | async"></app-tag-multi-select>
            <app-search-outline [searchInput]="searchInput"></app-search-outline>
        </div>

        <app-module-dialog-list
            [dataSource]="dataSource"
            [displayedColumns]="displayedColumns"
            [entitie$]="entitie$"
            [totalCount$]="totalCount$"
            [searchInput]="searchInput"
            [selectedModules]="modulesList"
            [tag$]="tagMultiSelectService.selectedTag$"
            (addedToList)="addToList($event); onSelection()"
            (removedFromList)="removeFromList($event); onSelection()"
            (loadModules)="loadModulesPage($event)"
        ></app-module-dialog-list>
    </div>

    <mat-checkbox class="mt-16 shrink-0" [(ngModel)]="isUnassignedSelected" (change)="onSelection()">
        {{ 'GENERAL.LABEL.UNASSIGNED' | translate }}
    </mat-checkbox>
</div>

<ng-template #tableShimmer>
    <div class="filter-by-module-content">
        <h3 class="mt-0 mb-12 shrink-0">{{ 'MODULE.SINGULAR' | translate }}</h3>
        <div class="table-wrapper filter-table-shimmer">
            <div class="shimmer-container py-16 px-16">
                <div class="shimmer" *ngFor="let item of [1, 2, 3, 4, 5, 6]">
                    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                        <div class="shimmer-title w-100-p animate mb-0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
